module.exports = __webpack_public_path__ + "img/17_windAndRain_lzk.e364a09d.png";